import { inject } from '@angular/core';
import { TranslateLoader, Translation } from '@ngx-translate/core';
import { LanguageAvailable } from '@shared/services/language/registry';
import { LogsService } from '@shared/services/logs';
import { ca_ES, es_ES, fr_BE, fr_FR, nl_BE } from 'public/i18n';
import { Observable, of } from 'rxjs';

const TRANSLATIONS: Readonly<Record<LanguageAvailable, Translation>> = {
  'fr-FR': fr_FR,
  'es-ES': es_ES,
  'ca-ES': ca_ES,
  'fr-BE': fr_BE,
  'nl-BE': nl_BE,
};

export class CustomTranslateLoader implements TranslateLoader {
  private readonly logs = inject(LogsService);

  getTranslation(lang: string): Observable<Translation> {
    if (!Object.hasOwn(TRANSLATIONS, lang)) {
      // An empty dictionary renders as the fallback language, invisibly: DIGSOC-5186.
      this.logs.error('CustomTranslateLoader', `No translation bundle found for "${lang}"`);
      return of({});
    }
    return of(TRANSLATIONS[lang as LanguageAvailable]);
  }
}
